import type { RouteObject } from "react-router";

/**
 * Routes under /t/:chain/:token owned by the overview_tape slice.
 *
 * Every view is `lazy`: a static import would put the whole app — echarts and
 * lightweight-charts included — in the entry graph, and Vite would then
 * modulepreload all of it on /login and on the home redirect.
 */
export const overviewTapeRoutes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import("./OverviewView")).default }) },
  { path: "tape", lazy: async () => ({ Component: (await import("./TapeView")).default }) },
];
